package com.daytimegaming.ourdailyfinances.domain.model

import com.daytimegaming.ourdailyfinances.data.network.dto.UserResponseDto
import com.daytimegaming.ourdailyfinances.data.network.dto.SubscriptionDto
import com.daytimegaming.ourdailyfinances.data.network.dto.BillingHistoryDto

data class UserProfile(
    val userId: String,
    val email: String,
    val firstName: String?,
    val lastName: String?,
    val subscription: UserSubscription? = null,
)

data class UserSubscription(
    val active: Boolean,
    val tier: String,
    val source: String?, // "web", "google_pay", "apple_pay"
    val billingHistory: List<BillingPeriod>,
)

data class BillingPeriod(
    val id: String,
    val status: String,
    val tier: String,
    val source: String?,
    val startedAt: String,
    val expiresAt: String,
)

fun UserResponseDto.toDomain() = UserProfile(
    userId = userId,
    email = userEmail,
    firstName = userFirstName,
    lastName = userLastName,
    subscription = subscription?.toDomain(),
)

fun SubscriptionDto.toDomain() = UserSubscription(
    active = active,
    tier = tier,
    source = billingHistory.firstOrNull { it.status == "active" }?.source,
    billingHistory = billingHistory.map { it.toDomain() },
)

fun BillingHistoryDto.toDomain() = BillingPeriod(
    id = id,
    status = status,
    tier = tier,
    source = source,
    startedAt = startedAt,
    expiresAt = expiresAt,
)

